import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNil } from 'lodash';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import ProvisionContainer from 'containers/CourtManagerLegalProceedings/Provision';
import { Listings } from 'containers/AppContainer/typings';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import RegulationContainer from 'containers/CourtManagerLegalProceedings/Provision/Regulation';
import {
  PROVISION_TAB_LABELS,
  REGULATION_TAB_LABELS,
} from 'containers/CourtManagerLegalProceedings/constants';
import RegulationTable from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationRecapContainer';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import routesHelper from 'containers/services/routes-helper';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import {
  isBlockStatusClaim,
  isLockedClaim,
} from 'containers/CourtManagerLegalProceedings/utils';
import * as featureService from 'features/fflip-helpers';
import { PAGES } from 'routes';
import { FEATURES } from 'features/features';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { resolveSagisClaim } from 'helpers/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { ClaimRecapType } from 'typings/claimTypes';
import { OPENING_STATE } from 'services/constants';

export interface ProvisionRegulationContainerProps {
  intl: IntlShape;
  listings: Listings;
  claimRecap: ClaimRecapType;
  claimNumber: string;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  setIsDetail?: Function;
  requestValidateProvisionIntervenant: Function;
  claimId: number;
  requestCreateStakeHolder?: Function;
  uploadedDocument: any;
  resetUploadDocumentStore: Function;
  uploadDocument: Function;
  requestCreateFeeNoteManager: Function;
  currentRegulationPath: any;
  regulations: any;
  judgementOnMeritsByVictims: any;
  requestGetRegulations: Function;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVehicles: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  requestCreateCorpoEncryptedDocument: Function;
  corporealEncryptedDocuments: any;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  requestMaterialEncryptedDocument: Function;
  requestGetAssignedLawyers: Function;
  assignedLawyers: any;
  requestGetDahirAmount: Function;
  requestGetDahirAmountCorpo: Function;
  dahirAmountsCorpo: any;
  dahirAmount: any;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  policyInfo: any;
  requestValidateProvision: Function;
  materialEncryptedDocuments: any;
  corpoRegulations: any;
  resetSearchClaimsStore: Function;
  resetStoreClaim: Function;
  resetSagisInfoClaim: Function;
  resetLegalProceeding: Function;
  isLawyer?: boolean;
  requestSetPriorityClaimProvision?: Function;
  match: { params: { claimId: number } };
  requestUnlockClaim: Function;
  setLockedClaim: Function;
  requestLockClaim: Function;
  requestResetHistoryStore: Function;
  requestSearchClaims: Function;
  isCourtManagerBasicManagementRegulation?: boolean;
}
export const ProvisionRegulationContainer: React.FC<ProvisionRegulationContainerProps> = (
  props,
): JSX.Element => {
  const [isDetail, setIsDetail] = React.useState(false);
  const [regulationDropDown, setRegulationDropDown] = React.useState(null);
  const [showAddRegulationForm, setShowAddRegulationForm] = React.useState(
    false,
  );
  const [currentRegulationTab, setCurrentRegulationTab] = useState(0);

  useEffect(() => {
    if (currentRegulationTab === 0 && !isNil(props.claimNumber)) {
      !isNil(props.claimNumber) &&
        props.requestSagisClaimInfo(props.claimNumber);
      props.claimId && props.requestGetRegulations(props.claimId);
      return setShowAddRegulationForm(false);
    }
  }, [currentRegulationTab, props.claimRecap]);
  const provisionMenuElements = [
    {
      title: translate(messages.regulations, props),
      action: () => {
        setShowAddRegulationForm(true);
        setCurrentRegulationTab(1);
      },
    },
  ];

  useEffect(() => {
    if (
      (!isEmpty(props.claimRecap) &&
        !props.isLawyer &&
        (get(props.claimRecap, 'claim.status') !== STATUS_VALIDATED ||
          get(props, 'claimRecap.claim.openingState') !=
            OPENING_STATE.COMPLETED)) ||
      (!isEmpty(get(props.policyInfo, 'sagis', {})) &&
        !props.isLawyer &&
        isBlockStatusClaim(props.policyInfo))
    ) {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetSagisInfoClaim();
      props.resetLegalProceeding();
      routesHelper.pushTo(
        `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
          'match',
          'params',
          'claimId',
        ])}`,
      )();
    }
    // eslint-disable-next-line
  }, [props.policyInfo, props.claimRecap, props.currentRegulationPath]);

  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', [])) &&
      featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
      (isNil(get(props.claimRecap, 'claim.priorityReasonId', null)) ||
        get(props.claimRecap, 'claim.priorityReasonId', null) != 4)
    ) {
      const priorityReason = priorityClaimReason(
        [],
        !isEmpty(get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []))
          ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
              .map((el: any) => Number(el.riskProvisions))
              .reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue,
              )
          : 0,
        props.listings,
      );
      if (priorityReason && props.requestSetPriorityClaimProvision) {
        props.requestSetPriorityClaimProvision({
          id: Number(props.match.params.claimId),
          claimInfo: { priorityReasonId: priorityReason },
          username: currentUserStorage.get().username,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        });
      }
    }
  }, [props.policyInfo]);

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      return () => {
        props.requestUnlockClaim(
          {
            claimNumber: get(props.claimRecap, 'claim.claimNumber'),
          },
          () => {
            props.setLockedClaim(null);
            props.resetSearchClaimsStore();
            props.resetStoreClaim();
            props.requestResetHistoryStore();
          },
        );
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.requestResetHistoryStore();
      };
    }
  }, []);

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      const handleBeforeUnload = (event: any) => {
        const message = 'vous allez quitter le mode de gestion du sins';
        event.returnValue = message;
        props.requestUnlockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
      };

      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
      };
    }
  }, []);

  useDeepCompareEffect(() => {
    if (!isEmpty(get(props.policyInfo, 'sagis', {}))) {
      if (
        !isLockedClaim(props.policyInfo) &&
        featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM) &&
        !isNil(get(props.claimRecap, 'claim.claimNumber', null)) &&
        !isBlockStatusClaim(props.policyInfo) &&
        get(props, 'claimRecap.claim.status') === STATUS_VALIDATED
      ) {
        props.requestLockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
        props.setLockedClaim(get(props.claimRecap, 'claim.claimNumber'));
      }
    }
  }, [props.claimRecap, props.policyInfo]);
  useEffect(() => {
    props.resetSearchClaimsStore();
    if (
      !isEmpty(props.claimRecap) &&
      !isNil(get(props.claimRecap, 'claim.claimNumber', null))
    ) {
      const searchQuery = {
        claimNumber: get(props.claimRecap, 'claim.claimNumber', null),
      };

      props.requestSearchClaims(searchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap, props.currentRegulationPath]);

  const isBasicManagementRegulation =
    props.isCourtManagerBasicManagementRegulation &&
    get(props.claimRecap, 'claim.isBasicManagement', false) &&
    isEmpty(get(props.judgementOnMeritsByVictims, 'judgement', [])) &&
    isEmpty(
      get(props.judgementOnMeritsByVictims, 'judgementsWithCivjvm', []),
    ) &&
    isEmpty(
      get(props.judgementOnMeritsByVictims, 'judgementprocedureNatureIds', []),
    ) &&
    isEmpty(props.judgementOnMeritsByVehicles);

  return (
    <main>
      <LegalProceedingTabs
        labels={PROVISION_TAB_LABELS}
        currentTabIndex={
          !!props.currentRegulationPath?.tabIndex
            ? props.currentRegulationPath.tabIndex
            : 0
        }
      >
        <ProvisionContainer
          claimNumber={props.claimNumber}
          listings={props.listings}
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          sagisClaim={props.sagisClaim}
          setIsDetail={setIsDetail}
          requestValidateProvisionIntervenant={
            props.requestValidateProvisionIntervenant
          }
          requestCreateStakeHolder={props.requestCreateStakeHolder}
          claimId={props.claimId}
          isConsultation={false}
          lossDate={get(props.claimRecap, 'claim.lossDate')}
          uploadedDocument={props.uploadedDocument}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          requestCreateFeeNoteManager={props.requestCreateFeeNoteManager}
        />
        <LegalProceedingTabs
          labels={REGULATION_TAB_LABELS}
          currentTabIndex={currentRegulationTab}
          setCurrentInstanceTab={setCurrentRegulationTab}
        >
          <div>
            {provisionMenuElements && (
              <DropDownDecisionMenu
                setDropDown={setRegulationDropDown}
                dropDown={regulationDropDown}
                label={translate(messages.regulationRequest, props)}
                menuElements={provisionMenuElements}
                marginMenuList="10"
                width="250"
                backgroundColor="#F9BE00"
                textColor="#000"
                iconColor="#000"
              />
            )}
            <RegulationTable
              sagisClaim={props.sagisClaim}
              listings={props.listings}
              regulations={props.regulations}
              isConsultation={false}
              isRecap={
                !isEmpty(get(props.currentRegulationPath, 'paymentId', ''))
              }
              paymentIdPath={get(
                props.currentRegulationPath,
                'paymentId',
                null,
              )}
              claimId={props.claimId || props.match.params.claimId}
              isBasicManagementRegulation={isBasicManagementRegulation}
            />
          </div>
          {showAddRegulationForm && (
            <RegulationContainer
              sagisClaim={props.sagisClaim}
              claimRecap={props.claimRecap}
              listings={props.listings}
              judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
              requestGetJudgementOnMeritsByVictims={
                props.requestGetJudgementOnMeritsByVictims
              }
              judgementOnMeritsByVehicles={props.judgementOnMeritsByVehicles}
              requestGetJudgementOnMeritsByVehicles={
                props.requestGetJudgementOnMeritsByVehicles
              }
              requestCreateCorpoEncryptedDocument={
                props.requestCreateCorpoEncryptedDocument
              }
              corporealEncryptedDocuments={props.corporealEncryptedDocuments}
              requestCreateCorporealRegulation={
                props.requestCreateCorporealRegulation
              }
              requestCreateMaterialRegulation={
                props.requestCreateMaterialRegulation
              }
              requestCreateAdditionalWarrentiesRegulation={
                props.requestCreateAdditionalWarrentiesRegulation
              }
              requestMaterialEncryptedDocument={
                props.requestMaterialEncryptedDocument
              }
              materialEncryptedDocuments={props.materialEncryptedDocuments}
              requestGetAssignedLawyers={props.requestGetAssignedLawyers}
              assignedLawyers={props.assignedLawyers}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              requestGetDahirAmount={props.requestGetDahirAmount}
              requestGetDahirAmountCorpo={props.requestGetDahirAmountCorpo}
              dahirAmountsCorpo={props.dahirAmountsCorpo}
              dahirAmount={props.dahirAmount}
              uploadDocument={props.uploadDocument}
              resetUploadDocumentStore={props.resetUploadDocumentStore}
              uploadedDocument={props.uploadedDocument}
              requestValidateProvisionIntervenant={
                props.requestValidateProvisionIntervenant
              }
              createdRegulations={props.createdRegulations}
              requestCreateSummarySheetRegulation={
                props.requestCreateSummarySheetRegulation
              }
              uploadDocumentRegulation={props.uploadDocumentRegulation}
              corpoRegulations={props.regulations}
              policyInfo={props.policyInfo}
              requestValidateProvision={props.requestValidateProvision}
              isBasicManagementRegulation={isBasicManagementRegulation}
            />
          )}
        </LegalProceedingTabs>
      </LegalProceedingTabs>
    </main>
  );
};

export default injectIntl(ProvisionRegulationContainer);
